import styled from 'styled-components';
import { COLORS } from '@/theme';

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  border-radius: 0.5rem;
  padding: 0.75rem;
  background: ${COLORS.GRAY_LIGHT};
`;

export const StyledFieldLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;
